import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const PEPassportCardActions = {
  initPePassportCard: ({ commit }, index) => {
    commit('setPePassportCardLock', { index, lock: true })
  },
  pePassportCardCreate: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      post('/party_characteristics', {
        passports: {
          party_id: party.id,
          country_id: section.country_id,
          passport_number: section.passport_number,
          issue_date: section.issue_date,
          issue_date_format: section.issue_date_format,
          issue_date_uncertain: section.issue_date_uncertain,
          place_issued: section.place_issued,
          expiry_date: section.expiry_date,
          expiry_date_format: section.expiry_date_format,
          expiry_date_uncertain: section.expiry_date_uncertain,
          notes: section.notes,

        },
      }).
      then(({ data }) => {
        commit('setPePassportCardLock', { index: 'new', lock: true })
        commit('setPePassportCardLock', { index: data.id, lock: true })
        commit('pePatchCharacteristicNew', {
          characteristic: 'passports',
          value: data,
        })

        return data
      }).
      catch(handleError)
  },
  pePassportCardRefresh: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty
    return axiosRequest.
      get(`/parties/${party.id}/party_characteristics/passports/${section.id}`).
      then(({ data }) => {
        commit('setPePassportCardLock', { index, lock: true })
        commit('pePatchCharacteristic', {
          characteristic: 'passports',
          value: data,
        })

        return data
      }).
      catch(handleError)
  },
  pePassportCardUpdate: async ({ commit, getters }, { id, section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      patch(`/party_characteristics/${id}`, {
        passports: {
          party_id: party.id,
          country_id: section.country_id,
          passport_number: section.passport_number,
          issue_date: section.issue_date,
          issue_date_format: section.issue_date_format,
          issue_date_uncertain: section.issue_date_uncertain,
          place_issued: section.place_issued,
          expiry_date: section.expiry_date,
          expiry_date_format: section.expiry_date_format,
          expiry_date_uncertain: section.expiry_date_uncertain,
          notes: section.notes,
        },
        id,
      }).
      then(({ data }) => {
        commit('setPePassportCardLock', { index, lock: true })
        commit('pePatchCharacteristic', {
          characteristic: 'passports',
          value: data,
        })

        return data
      }).
      catch(handleError)
  },
  pePassportCardDelete: async ({ commit, getters }, { id, index }) => {
    const party = getters.peParty

    return axiosRequest.
      delete(`/party_characteristics/${id}`, {
        data: {
          passports: {
            party_id: party.id,
          },
          id,
        },
      }).
      then(({ data }) => {
        const passports = data.passports || []

        commit('setPePassportCardLock', { index, lock: true })
        commit('pePatchParty', {
          passports,
        })
      }).
      catch(handleError)
  },
  pePassportCardAddSection: ({ commit }) => {
    commit('setPePassportCardLock', { index: 'new', lock: false })
    commit('addPePassportCardSection', {
      id: null,
      country_id: null,
      passport_number: null,
      issue_date: null,
      issue_date_format: null,
      issue_date_uncertain: null,
      place_issued: null,
      expiry_date: null,
      expiry_date_format: null,
      expiry_date_uncertain: null,
      notes: null,
    })
  },
}

export const PEPassportCardMutations = {
  setPePassportCardLock: (state, { index, lock }) => {
    if (!state.partyEdit.partySections.PassportCard) Vue.set(state.partyEdit.partySections, 'PassportCard', {})
    Vue.set(state.partyEdit.partySections.PassportCard, index, lock)
  },
  addPePassportCardSection: (state, section) => {
    state.partyEdit.party.passports.push(section)
  },
  pePassportCardCreateUndo: state => {
    state.partyEdit.party.passports.pop()
    Vue.set(state.partyEdit.partySections.PassportCard, 'new', true)
  },
}

export const PEPassportCardGetters = {
  pePassportCardLock: state => index => state.partyEdit.partySections.PassportCard[index],
  pePassportCardHasNewSection: (_, getters) => !!getters.peParty.passports?.find(passport => passport.id === null),
}
